import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import pdficon from "../assets/pdficon.png";
import DoneGreen from "../assets/doneGreen.svg";
import {
  computeTodayDate,
  mondayDayYearFormat,
  handleAphabetsChange,
  handleAlphabetsNumberWithoutSpaceChange,
  handleIaphabetnumberChange,
  handleError,
} from "../CommonJquery/CommonJquery.js";
import {
  update_booking_car_in_review,
  server_post_data,
  upload_image_to_folder,
  multicar_upload_image,
} from "../ServiceConnection/serviceconnection.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UpdatePolicyModal = ({
  modalShow1,
  handleClose,
  SelectedData,
  activeAgree1,
  handleActiveDeactive,
  APL_LINK,
  triggerDownloadPDF,
  openCustomDatePicker,
  DringImg,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [DamageImg, setDamageImg] = useState([]);
  const [damnageImgPath, setdamnageImgPath] = useState("");
  function cleanInput(inputStr) {
    if (typeof inputStr !== "string") return "";

    let parts = inputStr.split("~@~");

    // Get items before and after ~@~
    let before = parts[0] || "";
    let after = parts[1] || "";

    // Split both by commas, remove "Other" and trim spaces
    let items = [...before.split(","), ...after.split(",")]
      .map((item) => item.trim())
      .filter((item) => item && item.toLowerCase() !== "other");

    // Return cleaned result
    return items.join(", ");
  }
  const master_data_get = async () => {
    const fd = new FormData();
    fd.append("booking_id", SelectedData.primary_id);
    fd.append("image_status", 10);
    // console.log("image finction");
    await server_post_data(multicar_upload_image, fd)
      .then((Response) => {
        //console.log("Response", Response)
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setdamnageImgPath(Response.data.message.image_link_liCENCE);
          setDamageImg(Response.data.message.damage_image);
          console.log(Response.data.message.damage_image);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  useEffect(() => {
    if (SelectedData && SelectedData.primary_id) {
      master_data_get();
    }
  }, [SelectedData]);
  return (
    <Modal
      show={modalShow1}
      className="releaseModal releaseModalBody"
      centered
      onHide={(e) => handleClose(0)}
      size="lg"
      scrollable
    >
      <Modal.Header className="releaseModalHeader">
        Update Insurance Details
      </Modal.Header>
      <Modal.Body className="releaseModalBody">
        <div className="releaseModalHead">
          <div className="releaseModalDetails">
            {/* Car Details Table */}
            <table className="table">
              <thead>
                <tr style={{ borderBottom: "transparent" }}>
                  <th style={{ paddingBottom: "0.5rem" }}>Car Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fadeColor">Name</td>
                  <td>
                    {SelectedData?.car_data?.[0]?.car_name} (
                    {SelectedData?.car_data?.[0]?.car_tagline})
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">Licence Plate No.</td>
                  <td>{SelectedData?.car_data?.[0]?.car_no}</td>
                </tr>
                <tr>
                  <td className="fadeColor">VIN</td>
                  <td>{SelectedData?.car_data?.[0]?.vin}</td>
                </tr>
              </tbody>
            </table>

            {/* Driver Details Table */}
            <table className="table">
              <thead>
                <tr style={{ borderBottom: "transparent" }}>
                  <th style={{ paddingBottom: "0.5rem" }}>Driver's Detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="fadeColor">Name</td>
                  <td>{SelectedData.name}</td>
                </tr>
                <tr>
                  <td className="fadeColor">EMAIL</td>
                  <td>{SelectedData.email}</td>
                </tr>
                <tr>
                  <td className="fadeColor">MOBILE NO</td>
                  <td>{SelectedData.mobile_no}</td>
                </tr>
                <tr>
                  <td className="fadeColor">Current Address</td>
                  <td>
                    {SelectedData.present_map_address}, {SelectedData.pin_code}
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">State</td>
                  <td>{SelectedData.state}</td>
                </tr>
                <tr>
                  <td className="fadeColor">Pickup Date</td>
                  <td>{mondayDayYearFormat(SelectedData.from_date)}</td>
                </tr>
                {/* <tr>
                  <td className="fadeColor">Approved by Rideshare</td>
                  <td>{cleanInput(SelectedData.ready_for_rideshare)}</td>
                </tr> */}
                <tr>
                  <td className="fadeColor">Approved by Rideshare</td>
                  <td
                    className={`${
                      SelectedData.ready_for_rideshare === "yes"
                        ? ""
                        : "text-danger"
                    }`}
                    style={{
                      backgroundColor:
                        SelectedData.ready_for_rideshare === "yes"
                          ? ""
                          : "#f8d7da",
                    }}
                  >
                    {SelectedData.ready_for_rideshare === "yes" ? "Yes" : "No"}
                  </td>
                </tr>

                {SelectedData.ready_for_rideshare === "yes" ? (
                  <>
                    <tr>
                      <td className="fadeColor">Years of hire experience</td>
                      <td>{SelectedData.passenger_for_hire_expe}</td>
                    </tr>
                    <tr>
                      <td className="fadeColor">
                        Approved and ready to work for
                      </td>
                      <td>{cleanInput(SelectedData.work_for)}</td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td className="fadeColor">Using car for</td>
                    <td>{SelectedData.using_car_for}</td>
                  </tr>
                )}

                <tr>
                  <td className="fadeColor">How long need to rent the car</td>
                  <td>{SelectedData.long_need_car}</td>
                </tr>
                {SelectedData.ready_for_rideshare === "yes" && (
                  <tr>
                    <td className="fadeColor">Rideshare Approval Image</td>
                    <td style={{ textAlign: "left" }}>
                      {SelectedData.driving_licence}
                      <a
                        href={DringImg + SelectedData.rideshare_aproval_image}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          style={{ paddingTop: "0.2rem", width: "30px" }}
                          src={pdficon}
                          alt="Licence PDF"
                          onError={(e) => (e.target.style.display = "none")}
                        />
                      </a>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="fadeColor">Driver's License</td>
                  <td style={{ textAlign: "left" }}>
                    {SelectedData.driving_licence}
                    <a
                      href={APL_LINK + SelectedData.driving_licence_image_full}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ paddingTop: "0.2rem", width: "30px" }}
                        src={pdficon}
                        alt="Licence PDF"
                        onError={(e) => (e.target.style.display = "none")}
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td className="fadeColor">Download MVR Report</td>
                  <td>
                    {SelectedData.mvp_status === "yes" ? (
                      // <a
                      //   href={APL_LINK + SelectedData.mvp_pdf_full}
                      //   target="_blank"
                      //   rel="noopener noreferrer"
                      // >
                      //   <img
                      //     style={{
                      //       paddingTop: "0.2rem",
                      //       width: "30px",
                      //       // float: "right",
                      //     }}
                      //     src={pdficon}
                      //     alt="MVR PDF"
                      //     onError={(e) => (e.target.style.display = "none")}
                      //   />
                      // </a>
                      <>
                        {DamageImg &&
                          DamageImg.length > 0 &&
                          DamageImg.map((img, idx) => (
                            <a
                              href={APL_LINK + damnageImgPath + img.image}
                              key={idx}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                style={{
                                  paddingTop: "0.2rem",
                                  paddingLeft: "0.2rem",
                                  width: "30px",
                                }}
                                src={pdficon}
                                alt="Licence PDF"
                                onError={(e) =>
                                  (e.target.style.display = "none")
                                }
                              />
                            </a>
                          ))}
                      </>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Insurance Form */}
        <div
          className="releaseModalHeadLeft align-items-start"
          style={{ display: "flow" }}
        >
          <form id="update_policy_data">
            <div className="row">
              <div className="col-md-4">
                <label className="labelView">Insurance Policy ID</label>
                <input
                  type="text"
                  id="insurance_policy"
                  name="insurance_policy"
                  placeholder="Insurance Policy ID"
                  minLength={8}
                  maxLength={13}
                  className={`form-control input_field_custom1 ${
                    activeAgree1 ? "trio_mandatory" : ""
                  }`}
                  onInput={handleAlphabetsNumberWithoutSpaceChange}
                  style={{ paddingLeft: "1rem" }}
                />
              </div>
              <div className="col-md-4">
                <label className="labelView">Insurance Company Name</label>
                <input
                  type="text"
                  id="insurance_company"
                  name="insurance_company"
                  placeholder="Company Name"
                  minLength={3}
                  maxLength={100}
                  className={`form-control input_field_custom1 ${
                    activeAgree1 ? "trio_mandatory" : ""
                  }`}
                  onInput={handleIaphabetnumberChange}
                  style={{ paddingLeft: "1rem" }}
                />
              </div>
              <div className="col-md-4">
                <label className="labelView">Insurance Expiration Date</label>
                <div className="calendar_month_icon image_icon_position1 ">
                  <input
                    hidden
                    type="date"
                    id="insurance_expiration_date"
                    name="insurance_expiration_date"
                    min={computeTodayDate()}
                    // onClick={() =>
                    //   openCustomDatePicker("insurance_expiration_date")
                    // }
                    className={`form-control input_field_custom1 ${
                      activeAgree1 ? "trio_mandatory" : ""
                    }`}
                    placeholder="MM/DD/YYYY"
                    value={
                      selectedDate
                        ? selectedDate.toISOString().split("T")[0]
                        : ""
                    }
                    // readOnly
                  />
                  <DatePicker
                    minDate={computeTodayDate()}
                    dateFormat="MM/dd/yyyy" // 🇺🇸 USA Format
                    placeholderText="MM/DD/YYYY"
                    onChange={(date) => setSelectedDate(date)}
                    selected={selectedDate}
                    className={`form-control input_field_custom1 ${
                      activeAgree1 ? "trio_mandatory" : ""
                    }`}
                    style={{ marginTop: "5px" }}
                  />
                </div>
              </div>
            </div>
            {!activeAgree1 && (
              <div className="mt-3">
                <input
                  type="text"
                  id="reason_for_cancel"
                  name="reason_for_cancel"
                  placeholder="Reason for cancel"
                  minLength={3}
                  maxLength={75}
                  className="form-control input_field_custom1 trio_mandatory"
                  onInput={handleAphabetsChange}
                />
              </div>
            )}
          </form>
        </div>

        {/* Documents Section */}
        <div className="buttnsActionsForm">
          <p>Download Documents</p>
          <div className="downLoddBttns">
            <button
              type="button"
              onClick={() => triggerDownloadPDF(SelectedData)}
            >
              Application
            </button>
          </div>
        </div>

        {/* Status Message */}
        <div className="releaseModalHeadLeft align-items-start mt-5">
          <img
            src={DoneGreen}
            alt="Success Icon"
            style={{ paddingTop: "0.2rem" }}
          />
          <h5>
            <span>&nbsp;{SelectedData.show_msg}</span>
          </h5>
        </div>
      </Modal.Body>

      {/* Footer Buttons */}
      <Modal.Footer className="releaseModalFooter row">
        <Button
          className={`releaseModalBtn ${SelectedData.button_class} col-sm-6`}
          style={{ backgroundColor: "green" }}
          onClick={() => handleActiveDeactive(true)}
        >
          Update
        </Button>
        <Button
          className="editNowBtn Edit_Now col-sm-6"
          onClick={(e) => handleClose(1)}
        >
          <label style={{ cursor: "pointer" }}>
            {SelectedData.button_name_next}
          </label>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdatePolicyModal;
